/**
 * Shell = Wrapper (100% width + background); Inner = ContentInner (max 1440 centered)
 */
import styled from 'styled-components'
import { ContentInner } from '../../theme/components'

export const Wrapper = styled.section`
  box-sizing: border-box;
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  padding-block: var(--spacing-64);
  background: #f7f7f5;

  @media (max-width: 1024px) {
    padding-block: var(--spacing-40);
  }
`

export const Inner = styled(ContentInner)`
  display: flex;
  align-items: flex-end;
  gap: 80px;
  .copySection {
    display: flex;
    flex: 1 0 0;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-16);
    min-width: 0;
  }
  .copyTitle {
    margin: 0;
    color: var(--neutral-darkest);
    font: 600 32px/38px var(--font-barlow-semi-condensed);
    letter-spacing: 0;
    text-transform: capitalize;
  }
  .copyBody {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-16);
    width: 100%;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-32);
  }
`

export const CopyParagraph = styled.p`
  margin: 0;
  width: 100%;
  color: var(--neutral-body);
  font: 400 14px/22px var(--font-inter);
  letter-spacing: 0;

  strong, b {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-weight: 600;
    letter-spacing: inherit;
    line-height: inherit;
  }

  em, i {
    font-style: italic;
  }
`

export const IconsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  grid-auto-rows: 100px;
  width: 408px;
  min-height: 200px;
  box-sizing: content-box;
  background: var(--neutral-lightest-block);
  border: var(--border-regular) solid var(--neutral-border-light);

  @media (max-width: 1024px) {
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: auto;
    min-height: 0;
  }
`

export const IconImage = styled.img`
  max-width: 102px;
  width: 100%;
  height: 100px;
  padding: 8px;
  object-fit: contain;
  border: var(--border-thin) solid var(--neutral-border-light);
  background: var(--neutral-white);

  @media (max-width: 1024px) {
    box-sizing: border-box;
    max-width: 100%;
    height: 100px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductInfoBlock/styledComponents.tsx